/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const TradingSignalBorderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={20}
    fill="none"
    {...props}
    data-palette="TradingSignalBorderIcon">
    <path
      fill="var(--secondaryText)"
      fillRule="evenodd"
      d="M14.572 3.619A3.621 3.621 0 0 1 18.195 0a3.621 3.621 0 0 1 3.624 3.619 3.621 3.621 0 0 1-3.624 3.62 3.621 3.621 0 0 1-3.623-3.62ZM18.195.821a2.8 2.8 0 0 0-2.801 2.798 2.8 2.8 0 0 0 2.801 2.798 2.8 2.8 0 0 0 2.802-2.798A2.8 2.8 0 0 0 18.195.821Z"
      clipRule="evenodd"
    />
    <path
      fill="var(--brand-bg-primary)"
      fillRule="evenodd"
      d="M18.195 1.339c.228 0 .412.167.412.372v.203c.319.07.627.21.843.406.16.145.16.381 0 .526a.442.442 0 0 1-.581 0c-.134-.12-.416-.23-.685-.237-.155-.004-.252.028-.3.061-.032.022-.08.067-.08.204 0 .05.011.07.017.08.008.012.025.031.068.056.103.059.257.1.495.16l.026.006c.201.05.475.116.694.243a.97.97 0 0 1 .332.302c.09.137.134.293.134.461a.973.973 0 0 1-.472.845c-.15.095-.318.156-.491.19v.274c0 .205-.184.372-.412.372-.227 0-.41-.167-.41-.372v-.293c-.337-.077-.666-.24-.882-.502a.35.35 0 0 1 .082-.52.44.44 0 0 1 .576.074c.112.135.363.246.65.256a.756.756 0 0 0 .416-.088c.07-.045.121-.11.121-.236 0-.049-.011-.07-.018-.08a.192.192 0 0 0-.068-.055c-.102-.06-.256-.101-.494-.16l-.026-.006c-.202-.05-.475-.117-.694-.243a.972.972 0 0 1-.333-.302.824.824 0 0 1-.134-.462c0-.337.141-.616.406-.797.122-.084.258-.138.397-.17V1.71c0-.205.184-.372.412-.372Zm-.014 3.91.014-.372-.014.372Z"
      clipRule="evenodd"
    />
    <path
      fill="var(--secondaryText)"
      d="M5.513 13.315v-1.257h-1a.656.656 0 0 1-.483-.194.655.655 0 0 1-.194-.482v-6.11a.661.661 0 0 1 .677-.684h1V3.332c0-.119.04-.218.12-.298.081-.08.18-.12.3-.12.118 0 .217.04.298.12.08.08.12.18.12.298v1.256h1c.192 0 .353.065.483.194.13.13.194.29.194.483v6.11a.661.661 0 0 1-.677.683h-1v1.257a.41.41 0 0 1-.42.419.406.406 0 0 1-.297-.121.403.403 0 0 1-.121-.298Zm-.839-2.094H7.19V5.426H4.674v5.795ZM11.45 13.315v-2.932h-1a.657.657 0 0 1-.483-.194.655.655 0 0 1-.195-.482V6.042a.661.661 0 0 1 .678-.684h1V4.102c0-.119.04-.218.12-.298.08-.08.18-.12.299-.12.118 0 .218.04.298.12.08.08.12.18.12.298v1.256h1c.193 0 .354.065.483.195.13.13.195.29.195.482V9.7a.661.661 0 0 1-.678.683h-1v2.932a.41.41 0 0 1-.42.419.406.406 0 0 1-.297-.121.403.403 0 0 1-.12-.298Zm-.84-3.77h2.517v-3.35H10.61v3.35Z"
    />
    <path
      fill="var(--brand-bg-primary)"
      fillRule="evenodd"
      d="M19.88 8.806a.354.354 0 0 0-.366-.34l-3.185.119a.354.354 0 1 0 .026.707l2.202-.082-5.29 5.491c-.243.253-.58.396-.931.396h-8.18a.442.442 0 1 0 0 .884h8.542c.367 0 .718-.149.972-.413l1.171-1.218.016.015.879-.945 3.473-3.612.083 2.206a.354.354 0 0 0 .708-.027l-.12-3.18Z"
      clipRule="evenodd"
    />
    <path
      stroke="var(--secondaryText)"
      strokeLinecap="round"
      strokeWidth={0.905}
      d="M13.214.905H2.81c-1 0-1.81.81-1.81 1.81V17.19C1 18.19 1.81 19 2.81 19h15.38c1 0 1.81-.81 1.81-1.81v-.452"
    />
  </svg>
);
export default TradingSignalBorderIcon;
